<template>
  <div v-show="!isUserScrolling" :class="!showLanguage ? 'sammio-footer sammio-footer--two_cols' : 'sammio-footer' ">
    <div class="sammio-footer__container">
        <div :class="isExpanded ? 'sammio-footer__item mobile-nav--visible' : 'sammio-footer__item'">
            <button
                class="btn btn--nostyle text-center"
                :aria-expanded="a11yState"
                :aria-haspopup="true"
                ref="footerNavToggler"
                v-on:click="isExpanded = !isExpanded"
            >
              <menu-icon v-if="!isExpanded" size="1.75x"></menu-icon>
              <x-icon v-else size="1.75x"></x-icon>
              <span class="sammio-footer__text">{{ $t('sammio.navigation.menu') }}</span>
            </button>
        </div>
        <router-link to="/muistilista" class="sammio-footer__item">
            <span class="nav__item--bookmarks sr-only">{{$t('sammio.bookmarks.title')}} </span>
            <favourite-single v-if="bookmarksEmpty"></favourite-single>
            <favourite-single-highlight v-if="!bookmarksEmpty"></favourite-single-highlight>
            <div class="sammio_bookmarks__count" v-if="!bookmarksEmpty">
                {{ bookmarkCount }}
            </div>
            <span class="sammio-footer__text">{{$t('sammio.bookmarks.title')}}</span>
        </router-link>

        <div v-if="showLanguage" :class="isLangSelExpanded ? 'sammio-footer__item mobile-nav--visible' : 'sammio-footer__item'">
          <button
              class="btn btn--nostyle text-center"
              :aria-expanded="langA11yState"
              :aria-haspopup="true"
              ref="footerLangToggler"
              :aria-label="$t('sammio.dropdown.select_language')"
              v-on:click="isLangSelExpanded = !isLangSelExpanded"
          >
            <globe-icon v-if="!isLangSelExpanded" size="1.75x"></globe-icon>
            <x-icon v-else size="1.75x"></x-icon>
            <span class="sammio-footer__text">{{ getCurrentLanguage }}</span>
          </button>
        </div>
    </div>

    <nav v-show="isExpanded" ref="footerNav" role="navigation" id="mobile-navigation" :class="isExpanded ? 'sammio-nav--mobile mobile-nav--visible' : 'sammio-nav--mobile' " :aria-label="$t('sammio.navigation.title')">
      <ul class="list-unstyled" :aria-label="$t('sammio.navigation.site_pages')">
        <li role="presentation" >
          <router-link
            :to="{name: 'search', query: this.$router.currentRoute.query}" exact
            @click.native="onExpandedMenuElementClick()"
            >
            {{$t('sammio.search')}}
          </router-link>
        </li>
        <li>
          <router-link
              :to="{name: 'announcement', query: this.$router.currentRoute.query, params: {page_change: 'full'}}"
              exact
              @click.native="onExpandedMenuElementClick()"
          >
            {{$t('sammio.announcement')}}
          </router-link>
        </li>
        <li role="presentation">
          <router-link
            to="/saadokset"
            @click.native="onExpandedMenuElementClick()"
            >
            {{$t('sammio.statutes.title')}}
          </router-link>
        </li>
        <li role="presentation">
          <router-link
            to="/valmishaut"
            @click.native="onExpandedMenuElementClick()"
            >
            {{$t('sammio.frequentsearches.title')}}
          </router-link>
        </li>
        <li role="presentation">
          <router-link
            to="/ohje"
            @click.native="onExpandedMenuElementClick()"
            >
            {{$t('sammio.help')}}
          </router-link>
        </li>
      </ul>

      <button @click="isExpanded = !isExpanded" class="sr-only">{{$t('sammio.closeMenu')}}</button>
    </nav>

    <nav v-show="isLangSelExpanded" role="navigation" id="mobile-language" ref="footerLang" :class="isLangSelExpanded ? 'sammio-nav--mobile sammio-nav--lang mobile-nav--visible' : 'sammio-nav--mobile sammio-nav--lang'">
      <sammio-change-language></sammio-change-language>
    </nav>
  </div>
</template>
<script>
  import {MenuIcon, GlobeIcon, XIcon} from 'vue-feather-icons'
  import SammioChangeLanguage from "@/components/SammioChangeLanguage";
  import FavouriteSingle from "./icons/FavouriteSingle"
  import FavouriteSingleHighlight from "./icons/FavouriteSingleHighlight"
  import {i18n} from "@/translations/i18n";

  export default {
    name: "SammioFooter",
    components: {
      MenuIcon,
      GlobeIcon,
      XIcon,
      SammioChangeLanguage,
      FavouriteSingle,
      FavouriteSingleHighlight
    },
    data() {
      return {
        isExpanded: false,
        isLangSelExpanded: false,
        a11yState: "false",
        langA11yState: "false",
        isUserScrolling: false,
        scrollTimeout: null,
        showLanguage: true
      }
    },
    computed: {
      bookmarksEmpty() {
        return this.$store.getters.getBookmarks.length === 0
      },
      bookmarkCount() {
        if (this.$store.getters.getBookmarks.length > 0) {
          return this.$store.getters.getBookmarks.length
        }
      },
      getCurrentLanguage() {
        return i18n.locale
      }
    },
    methods: {
      isVisible(elem) {
        return !!elem && !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length )
      },
      onExpandedMenuElementClick() {
        this.isExpanded = !this.isExpanded;
        this.$nextTick(function() {
            jQuery('html').focus();
        })
      }
    },
    watch: {
      isExpanded: function () {
        if (this.isExpanded) {
          this.a11yState = 'true'

          const element = this.$refs.footerNav;
          const focusable = element.querySelectorAll('a')[0];
          setTimeout(() => {
            focusable.focus()
          },2000)

          document.addEventListener("click", elem => {
            if (!event.target.contains(this.$refs.footerNavToggler) ) {
              if (!element.contains(event.target) && this.isVisible(element)) {
                this.isExpanded = false
              }
            }
          },false)
        } else {
          this.a11yState = 'false'
          this.$refs.footerNavToggler.focus()
        }
      },
      isLangSelExpanded: function () {
        if (this.isLangSelExpanded) {
          this.langA11yState = 'true'
          const element = this.$refs.footerLang;
          const focusable = element.querySelectorAll('a')[0];
          setTimeout(() => {
            focusable.focus()
          },2000)


          document.addEventListener("click", elem => {
            if (!event.target.contains(this.$refs.footerLangToggler)) {
              if (!element.contains(event.target) && this.isVisible(element)) {
                this.isLangSelExpanded = false
              }
            }
          },false)
        } else {
          this.langA11yState = 'false'
          this.$refs.footerLangToggler.focus()
        }
      }
    }
  }
</script>